export default __webpack_public_path__ + "static/media/Green dot button.0e36ea07.svg";